import { blogRootPathname } from '@config'
import { withDisplayName } from '@hocs/with-display-name'
import { Hyperlink } from '@ui/hyperlink'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulBlogArticleLink: Utils.EntryFC<
  Queries.ContentfulBlogArticleLinkFragment
> = ({
  content: { slug },
  children,
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <Hyperlink
    {...entryInspectorProps()}
    {...fieldInspectorProps({
      fieldId: 'slug',
    })}
    href={`${blogRootPathname}/${slug}`}
  >
    {children}
  </Hyperlink>
)

export const query = graphql`
  fragment ContentfulBlogArticleLink on ContentfulBlogArticle {
    ...ContentfulEntry
    slug
  }
`

export default withDisplayName(
  ContentfulBlogArticleLink,
  'ContentfulBlogArticleLink'
)
